module.exports = __webpack_public_path__ + "images/旅悦好物全景_02-1.jpg?v=4ebb234e";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue3/旅悦好物全景_02-1.jpg
 ** module id = 128
 ** module chunks = 1 2
 **/